import { render } from "./security.vue?vue&type=template&id=50d1e02e&scoped=true"
import script from "./security.vue?vue&type=script&lang=js"
export * from "./security.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-50d1e02e"

export default script